import React from "react"
import types from "prop-types"
import { isEqual } from "lodash-es"
import { useDispatch, useSelector } from "react-redux"
import {
  getFormQuestionAttributeEndDateQuestionUuid,
  getFormQuestionAttributeEndDateQuestionUuidOptions,
  setQuestionAttributeEndDateQuestionUuid,
} from "reduxSlices/formBuilderSlice"
import { QuestionSelect } from "shared/selects"

const EndDateQuestionUuid = ({ sectionIndex, questionIndex }) => {
  const dispatch = useDispatch()

  const questionEndDateQuestionUuid = useSelector(getFormQuestionAttributeEndDateQuestionUuid({ sectionIndex, questionIndex }))
  const questionEndDateQuestionOptions = useSelector(getFormQuestionAttributeEndDateQuestionUuidOptions({ sectionIndex, questionIndex }), isEqual)

  const updateEndDateQuestionUuid = (newEndDateQuestionUuid) => dispatch(setQuestionAttributeEndDateQuestionUuid({
    sectionIndex, questionIndex, newEndDateQuestionUuid,
  }))

  return (
    <QuestionSelect
      backspaceDelete={false}
      className="text-sm"
      isFullWidth
      onChange={updateEndDateQuestionUuid}
      placeholder="End date"
      questions={questionEndDateQuestionOptions}
      selectLabel="select end date question"
      selectedQuestionUuid={questionEndDateQuestionUuid}
      style={{ height: "32px" }}
    />
  )
}

EndDateQuestionUuid.propTypes = {
  sectionIndex: types.number.isRequired,
  questionIndex: types.number.isRequired,
}

export default EndDateQuestionUuid
